import type { FlatTranslationKey } from '@/core/types/i18n';

export type GuestTranslateFn = (key: FlatTranslationKey) => string;

export interface GuestLabels {
  readonly home: string;
  readonly unitDetails: string;
  readonly breadcrumbHome: string;
  readonly breadcrumbUnitDetails: string;
  readonly exploreProperties: string;
  readonly aboutProperty: string;
  readonly documents: string;
  readonly brochure: string;
  readonly numberOfUnits: string;
  readonly unitType: string;
  readonly amenities: string;
  readonly login: string;
  readonly maybeLater: string;
  readonly loginPromptTitle: string;
  readonly loginPromptMessage: string;
  readonly emptyNoProperties: string;
  readonly emptyFetchError: string;
  readonly exploreEmpty: string;
  readonly unitsBadge: (count: number) => string;
  /** Greeting line on list, e.g. "Good evening !" (no comma — no name follows). */
  readonly greeting: (timeGreeting: string) => string;
}

export function getGuestLabels(t: GuestTranslateFn): GuestLabels {
  return {
    home: t('common.home'),
    unitDetails: t('guestWeb.unitDetails'),
    breadcrumbHome: t('guestWeb.breadcrumbHome'),
    breadcrumbUnitDetails: t('guestWeb.breadcrumbUnitDetails'),
    exploreProperties: t('guestWeb.exploreProperties'),
    aboutProperty: t('guestWeb.aboutProperty'),
    documents: t('guestWeb.documents'),
    brochure: t('guestWeb.brochure'),
    numberOfUnits: t('guestWeb.numberOfUnits'),
    unitType: t('guestWeb.unitType'),
    amenities: t('guestWeb.amenities'),
    login: t('guestWeb.login'),
    maybeLater: t('guestWeb.maybeLater'),
    loginPromptTitle: t('guestWeb.loginPromptTitle'),
    loginPromptMessage: t('guestWeb.loginPromptMessage'),
    emptyNoProperties: t('guestWeb.emptyNoProperties'),
    emptyFetchError: t('guestWeb.emptyFetchError'),
    exploreEmpty: t('guestWeb.exploreEmpty'),
    unitsBadge: (count: number) =>
      t('guestWeb.unitsBadge').replace('{{count}}', String(count)),
    greeting: (timeGreeting: string) =>
      t('guestWeb.greeting').replace('{{greeting}}', timeGreeting),
  };
}
